"use strict";

export default function () {
    const header = document.querySelector(".o-header");
    if (!header) return;

    window.addEventListener("scroll", () => {
        if (window.scrollY > 0) {
            header.classList.add("active");
        } else {
            header.classList.remove("active");
        }
    });
}
